import {
  getBatteryHistory,
  getWaterEvents,
  getWaterEvent,
  getFilterLife,
  getDeviceEvents,
  getLocationHistory,
} from '../services/apiServices';

export const tables = {
  battery: 'battery',
  usage: 'usage',
  location: 'location',
  waterChanges: 'waterChanges',
  filter: 'filter',
};

export const DETAIL_EVENT_TYPES = new Set(['mopping_event']);

export const EXPANDABLE_EVENT_TYPES = new Set(['mopping_session_event', 'water_change_event']);

export const NO_TOTAL_TIME_EVENTS = new Set([
  'wringer_removal',
  'wringer_attachment',
  'water_fill',
]);

const tablesConfig = {
  battery: {
    fetchFunction: getBatteryHistory,
    columns: [
      { label: 'Percentage', key: 'percentage' },
      { label: 'Time', key: 'time' },
      { label: 'Date', key: 'date' },
    ],
    title: 'Battery Life',
  },
  usage: {
    fetchFunction: getDeviceEvents,
    columns: [
      { key: 'location', label: 'Location' },
      { key: 'eventName', label: 'Event' },
      { key: 'timeRange', label: 'Time Range' },
      { key: 'duration', label: 'Total Time' },
      { key: 'date', label: 'Date' },
    ],
    title: 'Usage History',
  },
  location: {
    fetchFunction: getLocationHistory,
    columns: [
      { key: 'location', label: 'Location' },
      { key: 'total_duration', label: 'Total Time' },
      { key: 'time_range', label: 'Time Range' },
      { key: 'mopping_duration', label: 'Mopping Time' },
      { key: 'other_tasks_duration', label: 'No Activity Time' },
      { key: 'date', label: 'Date' },
    ],
    title: 'Location History',
  },
  waterChanges: {
    fetchFunction: getWaterEvents,
    fetchFunctionWithFilters: getWaterEvent,
    columns: [
      { key: 'event', label: 'Event' },
      { key: 'duration', label: 'Total Time' },
      { key: 'timeRange', label: 'Time Range' },
      { key: 'date', label: 'Date' },
    ],
    title: 'Water Change',
    labelType: 'cycles',
  },
  filter: {
    fetchFunction: getFilterLife,
    columns: [
      { header: 'Percentage', field: 'percentage' },
      { header: 'Time', field: 'time' },
      { header: 'Date', field: 'date' },
    ],
    title: 'Filter Life',
  },
};

export default tablesConfig;
